import { render, staticRenderFns } from "./BoxRoomBooking.vue?vue&type=template&id=5805a442&"
import script from "./BoxRoomBooking.vue?vue&type=script&lang=ts&"
export * from "./BoxRoomBooking.vue?vue&type=script&lang=ts&"
import style0 from "./BoxRoomBooking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports